import type { FilterOperator } from '@shared/types';

export const OPERATORS: { value: FilterOperator; label: string }[] = [
  { value: '==', label: 'Equals (==)' },
  { value: '!=', label: 'Not equals (!=)' },
  { value: '<', label: 'Less than (<)' },
  { value: '<=', label: 'Less or equal (<=)' },
  { value: '>', label: 'Greater than (>)' },
  { value: '>=', label: 'Greater or equal (>=)' },
  { value: 'in', label: 'In' },
  { value: 'not-in', label: 'Not in' },
  { value: 'array-contains', label: 'Array contains' },
  { value: 'array-contains-any', label: 'Array contains any' },
];

export function parseValueFromString(value: string): unknown {
  if (value === 'true') return true;
  if (value === 'false') return false;
  if (value === 'null') return null;
  if (!isNaN(Number(value)) && value !== '') return Number(value);
  if (value.startsWith('[') && value.endsWith(']')) {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
}

export function getValueDisplay(value: unknown): string {
  if (Array.isArray(value)) return JSON.stringify(value);
  if (value === null) return 'null';
  if (typeof value === 'boolean') return String(value);
  return String(value ?? '');
}

export function isArrayOperator(operator: string): boolean {
  return operator === 'in' || operator === 'not-in' || operator === 'array-contains-any';
}
